/* English dictionary: credit namespace. See src/i18n/README.md. */

import type { TextSpec } from '../text';

const credit = {
  'credit.section.libraries': [ 'Libraries' ],
  'credit.section.borrowed': [ 'Borrowed code & assets' ],
  'credit.note': [ 'License texts and fuller attribution are kept in the header comments of the corresponding source files.' ],
  'credit.what.pixi': [ 'WebGL 2D rendering engine' ],
  'credit.what.trystero': [ 'WebRTC P2P library' ],
  'credit.what.trysteroWsRelay': [ 'WebSocket relay for Trystero' ],
  'credit.what.tone': [ 'Web Audio scheduling and synthesis library' ],
  'credit.what.immer': [ 'Immutable state utility library' ],
  'credit.what.zod': [ 'Runtime data validation library' ],
  'credit.what.tsAsciiEngine': [ 'ASCII terminal rendering engine' ],
  'credit.what.alexharri': [ 'Shader used by the game background' ],
  'credit.what.webglNoise': [ 'Simplex noise used by the game background' ],
  'credit.what.glitch': [ 'Glitch filter/effect shader reference (work source code not included)' ],
  'credit.what.zenith': [ 'Zenith Tower - TETR.IO Original Soundtrack (game background music, unlicensed use, will remove upon request)' ],
} as const;

// 静态检查（写在对象字面量之外，避免 TextKey 循环推断）
credit satisfies Record<string, TextSpec>;
export default credit;
